import * as React from 'react';
// @mui
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// @mui icon
import LogoutIcon from '@mui/icons-material/Logout';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
//
import { useAuthContext, useBoolean, useRouter } from 'hooks';
//
import { StyledBadge } from './Base';
//
import { fDateTime } from 'utils/format-time';

import PasswordModal from './password-modal';
import LogoSVGNew from './LogoSVGNew';
import { useLocales } from 'locales';
import CycleSelect from "./CycleSelect";
import {getCycleFromLocalStorage} from "../utils/apis";
const Header = () => {
  const { user, logout } = useAuthContext();
  const { t, onChangeLang } = useLocales();

  const router = useRouter();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const changePassword = useBoolean();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    logout();
    router.replace('/login');
  }

  return (
    <AppBar position="static" sx={{ backgroundImage: 'unset' }}>
      <Container maxWidth="xl" >
        <Toolbar disableGutters>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              color="inherit"
              onClick={handleLogout}
            >
              <LogoutIcon />
            </IconButton>
          </Box>
          <Typography
            noWrap
            variant="h5"
            component="a"
            href="/admin/users"
            sx={{
              margin: 'auto',
              color: 'inherit',
              fontWeight: 700,
              letterSpacing: '.3rem',
              textDecoration: 'none',
              fontFamily: 'monospace',
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <LogoSVGNew width={160} height={30} />
          </Typography>

          <Box sx={{ flexGrow: 0 }}>
            <Button
              onClick={handleOpenUserMenu}
              sx={{
                py: 0,
                px: 2,
                display: 'flex',
                borderRadius: 0,
                color: '#ffffff',
                alignItems: 'center',
                bgcolor: '#ffffff36',
                justifyContent: 'space-between',
                minWidth: (theme) => theme.spacing(14),
                minHeight: (theme) => theme.spacing(8),
              }}
            >
              <StyledBadge
                variant="dot"
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              >
                <Avatar alt="User" src={require('assets/img/users/1.jpg')} />
              </StyledBadge>
              <Typography sx={{ color: 'inherit', ml: 1 }}>
                {user?.username}
              </Typography>
            </Button>
            <Menu
              sx={{
                mt: (theme) => theme.spacing(6),
                "& .MuiPopover-paper": {
                  borderRadius: 0
                }
              }}
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={() => {
                changePassword.onTrue();
                handleCloseUserMenu();
              }
              }>
                <Typography textAlign="center" sx={{ fontSize: (theme) => theme.spacing(1.5) }}>{t('Change Password')}</Typography>
              </MenuItem>
            </Menu>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              justifyContent: 'space-around',
              display: { xs: 'none', md: 'flex' },
            }}>
            <Stack direction="row" alignItems='center' gap={1}>
              <AccountBalanceWalletIcon color='disabled' />
              <Typography sx={{ color: (theme) => theme.palette.success.light }}>
                {user ? getCycleFromLocalStorage() === 'monthly' ? user.balance.toFixed(2) : user.weeklyBalance.toFixed(2) : '0.00'}
              </Typography>
            </Stack>

            <Stack direction="row" alignItems='center' gap={2}>
              <Box
                component="img"
                onClick={() => onChangeLang('en')}
                src="../assets/img/flags/en.svg"
                alt='lang'
                sx={{
                  cursor: 'pointer',
                  width: (theme) => theme.spacing(3),
                  height: (theme) => theme.spacing(2)
                }}
              />
              <Box
                component="img"
                onClick={() => onChangeLang('he')}
                src="../assets/img/flags/he.svg"
                alt='lang'
                sx={{
                  cursor: 'pointer',
                  width: (theme) => theme.spacing(3),
                  height: (theme) => theme.spacing(2)
                }}
              />
            </Stack>

            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/admin/users"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
              }}
            >
              {/*<img src={logo} alt="logo" width={80} height={47} />*/ }
            </Typography>

            <Stack direction='row' alignItems='center'>
              <Typography sx={{ color: 'white' }}>
                {fDateTime(new Date())}
              </Typography>
            </Stack>
              <Stack direction='row' alignItems='center'>
                  <CycleSelect />
            </Stack>
          </Box>

          <Box>
            <Button sx={{ display: { md: 'flex', xs: 'none' } }} onClick={handleLogout}>
              <LogoutIcon sx={{ color: 'white' }} />
              <Typography sx={{ color: 'white' }}>{t("logout")}</Typography>
            </Button>
          </Box>
        </Toolbar>
      </Container>
      <PasswordModal open={changePassword.value} onClose={changePassword.onFalse} />
    </AppBar>
  );
};
export default Header;
